<template>
  <div
    class="card mt-4"
  >
    <div
      class="card-header"
    >
      <h5>
        Geschiedenis
      </h5>

    </div>
    <div class="card-body d-flex">
      <log-item
        v-for="log in logs"
        :key="log.id"
        :log="log"
      />
      
      <div class="log-end">
        <div class="indicator" />
      </div>
    </div>
  </div>
</template>

<script>
import ReportDetailStore, { State } from '@/store/pages/Report/report-detail-store';

import LogItem from './LogItem.vue';
import ReportLogDto from '@/api/dto/report-log-dto';

const createDefaultLogEntry = () => new ReportLogDto({
  id: 0,
  user: {
    userName: '',
    type: 0,
    id: 0,
  },
  organizationId: ReportDetailStore.getters.report.organizationId,
  reportId: ReportDetailStore.getters.report.id,
  logContent: 'Melding aangemaakt',
  dateOfLog: ReportDetailStore.getters.report.createDate,
});

const placeholderLogs = [
  ReportLogDto.createPlaceholderLogItem(),
  ReportLogDto.createPlaceholderLogItem(),
  ReportLogDto.createPlaceholderLogItem(),
  ReportLogDto.createPlaceholderLogItem(),
  ReportLogDto.createPlaceholderLogItem(),
  ReportLogDto.createPlaceholderLogItem()
];

export default {
  components: {
    LogItem,
  },
  computed: {
    logs() {
      switch (ReportDetailStore.getters.state) {
        case State.loading:
          return placeholderLogs;
        case State.error:
          return [];
        default:
        return [
          ...ReportDetailStore.getters.logs.map(log => new ReportLogDto(log)),
          createDefaultLogEntry(),
        ];
      }
    },
    stateClass() {
      return {
        'placeholder': ReportDetailStore.getters.isLoading
      };
    },
  }
}
</script>

<style>
  .card-body {
    overflow-x: scroll;
  }

  .log-end {
    display: flex;
    align-items: flex-end;
    position: relative;

    &::after {
      content: '';
      display: block;
      position: absolute;
      bottom: -5px;
      width: 9px;
      height: 9px;
      border-radius: 50%;
      border: 1px solid #888;
      background: #888;
    }
  }
</style>